/* eslint-disable no-sequences */
import React from 'react';
import Return from '../../../images/return.png';
import LogoDiagnostico from '../../../images/logo-diagnostico.png';
import { BaSeButton, BaSeIcon, BaSeTag } from '@base/react';
import { AddPushModel } from './addDiagnostico.model';
import { mapValueMsg } from './mapValuesPage';
import { formatDefaultValueSelect } from '../../../utils/mask';
import { formatDateToBR } from '../../../utils/time';
import Tooltip from '@material-ui/core/Tooltip';
import { makeStyles } from '@material-ui/core/styles';
import styles from './styles.module.scss';

export const DEFAULT_VALUE_SELECIONE = 'Selecione';
export const DEFAULT_VALUE_ALL = 'Todos';

export const AddDiagnostico = (props) => {
  const { onClose, selectedRow, allValuesOptions, typeScreen } = props;

  const {
    diagnostico,
    setDiagnostico,
    isLoading,
    isLoadingCidades,
    cidades,
    newCPF,
    setNewCPF,
    isCPF,
    setIsCPF,
    planilha,
    setPlanilha,
    removeCPF,
    updateValue,
    updatePlanilha,
    recoveredByid,
    adicionarNotificacao,
    onChangeUF,
    cnaes,
    setCnaes,
    serviceData,
  } = AddPushModel({ selectedRow, typeScreen, onClose });

  const useStylesBootstrap = makeStyles(() => ({
    arrow: {
      color: '#CC66CC',
    },
    tooltip: {
      backgroundColor: '#CC66CC',
      minWidth: '940px',
      border: '1px solid',
    },
  }));

  const classesTooltip = useStylesBootstrap();

  const backList = () => {
    onClose();
  };

  const renderActions = () => {
    if (serviceData) {
      return (
        <Tooltip
          classes={classesTooltip}
          placement="left"
          leaveDelay={0}
          interactive
          arrow
          title={
            <React.Fragment>
              <div className={styles.tooltip_wrapper_previsualizar}>
                <h3>
                  {diagnostico?.servicoPredefinido?.nome.toUpperCase()} (
                  {serviceData.quantidadePerguntas} Perguntas)
                </h3>
                <br></br>
                {serviceData.temas?.map((el) => (
                  <>
                    <h4>{el.nome}</h4>
                    <br></br>
                    {el.subTemas?.map((el) => (
                      <>
                        <h5>{el.nome}</h5>
                        {el.perguntas?.map((el, index) => (
                          <p>
                            {index + 1}. {el}
                          </p>
                        ))}
                        <br></br>
                      </>
                    ))}
                    <br></br>
                  </>
                ))}
                {/* <h5></h5> */}
              </div>
            </React.Fragment>
          }
        >
          {/* <p className="text-campos-cadastro pre-visualizar-link"> */}
          <p className={styles.pre_visualizar_link}>Pré-visualizar</p>
        </Tooltip>
      );
    }
    return null;
  };

  return (
    <div>
      <div className={styles.container_principal}>
        <div
          className={styles.filtro_container}
          style={{ backgroundColor: '#cc66cc', height: '50px' }}
        >
          <div className={styles.modal_flex_direction_row}>
            <img
              alt="imagem"
              className="logo-diagnostico"
              src={LogoDiagnostico}
            />
            <h2 className={styles.text_color_branco_titulo}>Diagnósticos</h2>
            <div className={styles.div_acoes_carrossel}>
              <div className={styles.icons_acoes_modal_filtro}>
                <img
                  onClick={backList}
                  alt="imagem"
                  className={styles.writin}
                  src={Return}
                />
                <p className={styles.text_color_branco}>Voltar</p>
              </div>
            </div>
          </div>
        </div>
        {/* <hr size="1" className="separador-servicos"></hr> */}
        <div>
          <div className={styles.div_tabelas_carrossel_filtro}>
            <div className={styles.separator_push_diagnostico}>
              <h3>{mapValueMsg[typeScreen]}</h3>
            </div>

            <div className={styles.div_acoes_diagnosticos}>
              <div className={styles.container_itens}>
                <p>
                  <p className="text-campos-cadastro">
                    Título do diagnóstico{' '}
                    <span className={styles.mandatory_diagnostico}>*</span>
                  </p>
                </p>
                <input
                  value={diagnostico?.titulo ?? ''}
                  id="input-nome"
                  onChange={(evento) => {
                    const newValue = evento.target.value;
                    if (newValue.length < 141)
                      updateValue('titulo', evento.target.value);
                  }}
                  placeholder="Digite aqui o título"
                />
                <div className={styles.sublabel_wrapper}>
                  <p className={styles.sublabel}>
                    {diagnostico?.titulo?.length ?? 0}/140
                  </p>
                </div>
              </div>

              <div
                className={styles.container_itens}
                style={{ display: 'flex' }}
              >
                <div style={{ flex: '1' }}>
                  <p className="text-campos-cadastro">
                    Palavras-chave
                    {/* <span className={styles.mandatory_diagnostico}>*</span> */}
                  </p>
                  <select
                    value={diagnostico?.palavrasChave?.[0]?.id ?? ''}
                    onChange={(event) => {
                      const recovered = recoveredByid(
                        allValuesOptions.palavrasChave,
                        event.target.value,
                        true
                      );
                      updateValue('palavrasChave', recovered);
                    }}
                  >
                    <option value={null}>{DEFAULT_VALUE_SELECIONE}</option>
                    {allValuesOptions.palavrasChave.map((pc) => (
                      <option value={pc.id} title={pc.palavra}>
                        {formatDefaultValueSelect(pc.palavra)}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
            </div>
            <div className={styles.div_acoes_diagnosticos}>
              <div className={styles.container_itens}>
                <p className="text-campos-cadastro">
                  Descrição do diagnóstico
                  <span className={styles.mandatory_diagnostico}>*</span>
                </p>
                <textarea
                  rows="7"
                  value={diagnostico?.descricao ?? ''}
                  id="input-descricao"
                  onChange={(evento) => {
                    const newValue = evento.target.value;
                    if (newValue.length < 501)
                      updateValue('descricao', evento.target.value);
                  }}
                  placeholder="Digite aqui a descrição da funcionalidade"
                />
                <div className={styles.sublabel_wrapper}>
                  <p className={styles.sublabel}>
                    {diagnostico?.descricao?.length ?? 0}/500
                  </p>
                </div>
              </div>
              <div className={styles.container_itens}>
                <div>
                  <div>
                    <p className="text-campos-cadastro">
                      Tipo de usuário
                      <span className={styles.mandatory_diagnostico}>*</span>
                    </p>
                    <select
                      value={diagnostico?.perfis?.[0]?.id ?? ''}
                      onChange={(event) => {
                        const recovered = recoveredByid(
                          allValuesOptions.perfis,
                          event.target.value,
                          true
                        );
                        updateValue('perfis', recovered);
                      }}
                    >
                      <option value={''}>Todos</option>
                      {allValuesOptions.perfis.map((perfil) => (
                        <option value={perfil.id} title={perfil.nome}>
                          {formatDefaultValueSelect(perfil.nome)}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div>
                    <div className={styles.pre_visualizar_container}>
                      <p className="text-campos-cadastro">
                        Diagnóstico habilitado
                        <span className={styles.mandatory_diagnostico}>*</span>
                      </p>
                      {diagnostico?.servicoPredefinido?.id
                        ? renderActions()
                        : null}
                    </div>
                    <select
                      value={diagnostico?.servicoPredefinido?.id ?? ''}
                      onChange={(event) => {
                        const recovered = recoveredByid(
                          allValuesOptions.servicosPredefinidos,
                          event.target.value,
                          true
                        );
                        updateValue('servicoPredefinido', recovered[0]);
                      }}
                    >
                      <option value={''}>Selecione o Serviço...</option>
                      {allValuesOptions.servicosPredefinidos.map((pre) => (
                        <option value={pre.id} title={pre.nome}>
                          {formatDefaultValueSelect(pre.nome)}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
              </div>
            </div>
            <div className={styles.div_acoes_diagnosticos}>
              <div className={styles.div_acoes_diagnosticos}></div>
            </div>

            <div className={styles.div_acoes_diagnosticos}>
              <div className={styles.container_itens}>
                <div style={{ width: '90%', display: 'flex' }}>
                  <div className={styles.input_container}>
                    <p className="text-campos-cadastro">
                      Tipo de diagnóstico
                      <span className={styles.mandatory_diagnostico}>*</span>
                    </p>
                    <select
                      value={diagnostico?.tipo ?? ''}
                      onChange={(event) => {
                        updateValue('tipo', event.target.value);
                      }}
                    >
                      <option value={null}>{DEFAULT_VALUE_SELECIONE}</option>
                      {allValuesOptions.tipos.map((tipo) => {
                        return (
                          <option value={tipo} title={tipo}>
                            {formatDefaultValueSelect(tipo)}
                          </option>
                        );
                      })}
                    </select>
                  </div>
                </div>
              </div>
            </div>

            <div className={styles.div_acoes_diagnosticos}>
              <div className={styles.container_itens}></div>
            </div>

            <div className={styles.separator_push_diagnostico}>
              <h3>Abrangência do diagnóstico</h3>
            </div>

            <div className={styles.div_acoes_diagnosticos}>
              <div className={styles.container_itens}>
                <div style={{ display: 'flex' }}>
                  <div>
                    <p className="text-campos-cadastro">UF</p>
                    <select
                      value={diagnostico?.ufs?.[0]?.id ?? ''}
                      style={{ width: '80%', marginRight: '1rem' }}
                      onChange={(event) =>
                        onChangeUF(allValuesOptions.ufs, event.target.value)
                      }
                    >
                      <option value={null}>{DEFAULT_VALUE_SELECIONE}</option>
                      {allValuesOptions.ufs.map((uf) => (
                        <option value={uf.id} title={uf.nome}>
                          {uf.nome}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div style={{ flex: 1, maxWidth: 500 }}>
                    <p className="text-campos-cadastro">Cidade</p>
                    <select
                      disabled={isLoadingCidades}
                      value={diagnostico?.cidades?.[0]?.id ?? ''}
                      onChange={(event) => {
                        const recovered = recoveredByid(
                          cidades,
                          event.target.value,
                          true
                        );
                        updateValue('cidades', recovered);
                      }}
                    >
                      {isLoadingCidades ? (
                        <option value={null}>Carregando cidades</option>
                      ) : (
                        <>
                          <option value={null}>
                            {DEFAULT_VALUE_SELECIONE}
                          </option>
                          {cidades.map((cidade) => (
                            <option value={cidade.id} title={cidade.nome}>
                              {cidade.nome}
                            </option>
                          ))}
                        </>
                      )}
                    </select>
                  </div>
                </div>
              </div>
            </div>
            <div className={styles.div_acoes_diagnosticos}>
              <div className={styles.container_itens}>
                <div
                  className="accordion-content flex-1 column"
                  style={{ flex: '1' }}
                >
                  <div>
                    <p className="color-label text-campos-cadastro">
                      Tipo de usuário
                    </p>
                    <div
                      style={{ display: 'flex', flexDirection: 'row', flex: 1 }}
                    >
                      <div style={{ display: 'flex', flexDirection: 'row' }}>
                        <input
                          type="radio"
                          value={isCPF}
                          checked={isCPF}
                          onChange={() => {
                            setIsCPF(true);
                            setDiagnostico({
                              ...diagnostico,
                              cnpjs: [null],
                              portes: [null],
                              cnaes: [null],
                              segmentos: [null],
                            });
                          }}
                        />
                        <label className={styles.color_label_margin_left5}>
                          CPF
                        </label>
                      </div>
                      <div
                        style={{
                          display: 'flex',
                          flexDirection: 'row',
                          marginLeft: 10,
                        }}
                      >
                        <input
                          type="radio"
                          value={isCPF}
                          checked={!isCPF}
                          onChange={() => {
                            setIsCPF(false);
                            setDiagnostico({
                              ...diagnostico,
                              cpfs: [],
                            });
                          }}
                        />
                        <label className={styles.color_label_margin_left5}>
                          CNPJ
                        </label>

                        {/* Adicionar nome avulso */}
                        <input
                          placeholder={'Insira um CPF'}
                          type="text"
                          onChange={(event) => setNewCPF(event.target.value)}
                          // value={newCPF}
                          // className="margin-left-20"
                          style={{ marginLeft: '20px', marginTop: '0.5rem' }}
                        />

                        <div
                          style={{
                            marginLeft: '5px',
                            width: '2rem',
                            marginTop: '1rem',
                          }}
                        >
                          <BaSeIcon
                            name="plus-circle"
                            size={22}
                            color="#6c6c6c"
                            description="Ícone de adicionar CPF"
                            onClick={() =>
                              setPlanilha([...planilha, newCPF ?? [newCPF]])
                            }
                          />
                        </div>
                        <label
                          for="planilha"
                          style={{
                            marginLeft: '5px',
                            width: '2rem',
                            marginTop: '1rem',
                          }}
                        >
                          <BaSeIcon
                            name="document"
                            size={22}
                            color="#6c6c6c"
                            description="Ícone de adicionar lista"
                          />
                        </label>

                        {/* input de planilha escondido */}
                        <input
                          type="file"
                          id="planilha"
                          accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                          onChange={(event) => updatePlanilha(event)}
                          // className="hide-input"
                          style={{ display: 'none' }}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className={styles.container_itens}>
                <div className={styles.cpfs_container}>
                  {planilha &&
                    planilha.length > 0 &&
                    planilha.map((cpf, index) => (
                      <BaSeTag
                        borderColor="transparent"
                        iconBackgroundColor="#db340b"
                        iconColor="#ffffff"
                        label={cpf}
                        labelBackgroundColor="#cfe2fc"
                        labelColor="#005eb8"
                        onClose={() => removeCPF(index)}
                        size="medium"
                      />
                    ))}
                </div>
              </div>
            </div>

            {!isCPF && (
              <div className={styles.div_acoes_diagnosticos}>
                <div className={styles.container_itens}>
                  <p className="text-campos-cadastro">Porte</p>
                  <select
                    value={diagnostico?.portes?.[0]?.id ?? ''}
                    onChange={(event) => {
                      const recovered = recoveredByid(
                        allValuesOptions.portes,
                        event.target.value,
                        true
                      );
                      updateValue('portes', recovered);
                    }}
                  >
                    <option value={null}>{DEFAULT_VALUE_SELECIONE}</option>
                    {allValuesOptions.portes.map((pte) => (
                      <option value={pte.id} title={pte.nomePorte}>
                        {pte.nomePorte}
                      </option>
                    ))}
                  </select>
                </div>

                <div className={styles.container_itens}>
                  <p className="text-campos-cadastro">Segmentos</p>
                  <select
                    value={diagnostico?.segmentos?.[0]?.id ?? ''}
                    onChange={(event) => {
                      // const value = event.target.value;
                      updateValue('segmentos', parseInt(event.target.value));
                      if (event.target.value !== DEFAULT_VALUE_SELECIONE) {
                        const recovered = recoveredByid(
                          allValuesOptions.segmentos,
                          event.target.value,
                          true
                        );

                        setCnaes(recovered?.[0].cnaes);
                        updateValue('segmentos', recovered);
                      } else {
                        setCnaes([]);
                      }
                    }}
                  >
                    <option value={null}>{DEFAULT_VALUE_SELECIONE}</option>
                    {allValuesOptions.segmentos.map((seg) => (
                      <option value={seg.id} title={seg.nome}>
                        {seg.nome}
                      </option>
                    ))}
                  </select>
                </div>

                <div className={styles.container_itens}>
                  <p className="text-campos-cadastro">Cnae:</p>
                  <select
                    value={diagnostico?.cnaes?.[0]?.id ?? ''}
                    onChange={(event) => {
                      const recovered = recoveredByid(
                        diagnostico?.segmentos?.[0].cnaes,
                        event.target.value,
                        true
                      );
                      updateValue('cnaes', recovered);
                    }}
                  >
                    <option value={null}>{DEFAULT_VALUE_SELECIONE}</option>
                    {cnaes.map((cnae) => (
                      <option value={cnae.id} title={cnae.descricao}>
                        {cnae.descricao}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
            )}
            <div
              className={styles.div_acoes_diagnosticos}
              style={{ marginTop: '10px', marginBottom: '10px' }}
            >
              <div
                className={styles.container_itens}
                style={{ display: 'flex' }}
              >
                <div
                  style={{
                    display: 'flex',
                    flex: '1',
                    justifyContent: 'space-between',
                  }}
                >
                  <div style={{ flex: '1' }}>
                    <p className="text-campos-cadastro">Usuários que </p>
                    <select
                      value={diagnostico?.usuariosQue ?? ''}
                      onChange={(event) => {
                        updateValue('usuariosQue', event.target.value);
                      }}
                    >
                      <option value={null}>{DEFAULT_VALUE_SELECIONE}</option>
                      {allValuesOptions.usuariosQue.map((uq) => (
                        <option value={uq} title={uq}>
                          {formatDefaultValueSelect(uq)}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div style={{ alignSelf: 'flex-end', flex: '1' }}>
                    <BaSeButton
                      color="#cc66cc"
                      value={
                        typeScreen !== 3
                          ? 'Incluir Diagnóstico'
                          : 'Editar Diagnóstico'
                      }
                      onClick={adicionarNotificacao}
                      isLoading={isLoading}
                      isDisabled={isLoading}
                      loadingText={typeScreen !== 3 ? 'Salvando' : 'Editando'}
                    />
                  </div>
                </div>
              </div>
            </div>
            {/* Resgistro data INCLUSÃO-ALTERAÇÃO */}
            <div className={styles.updatedAt_diagnostico_container}>
              {diagnostico.atualizadoPor && typeScreen === 3 && (
                <h5>
                  Atualizado em {formatDateToBR(diagnostico.ultimaAtualizacao)}{' '}
                  por {diagnostico?.atualizadoPor?.nome}
                </h5>
              )}
              {diagnostico.criadoPor && typeScreen === 3 && (
                <h5>
                  Criado em {formatDateToBR(diagnostico.dataCriacao)} por{' '}
                  {diagnostico?.criadoPor?.nome}
                </h5>
              )}
              {console.log(diagnostico)}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
